// extracted by mini-css-extract-plugin
export var closeButton = "_fg-1";
export var closeX = "_fg-3";
export var container = "_fg-0";
export var image = "_fg-2";